import React, { useLayoutEffect } from 'react'
import { NavLink, useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { Button, Divider, Link, Typography } from '@material-ui/core'

import { whatsappChatProps } from '../../../../components/whatsapp-chat'
import { bookingPath } from '../../../../lib/booking-entry'
import { styles } from './styles'

// Once per module: makeStyles called inside a render built a new JSS sheet,
// with new class names, on every render (booking screen, 11 Oct 2026).
const useStyles = makeStyles(styles)

const CheckoutCancelingComponent = React.memo(() => {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <Typography className={classes.heading}>Your booking isn’t finished yet</Typography>
      <Divider />
      <Typography className={classes.text2}>It only takes a minute to finish. No payment was taken.</Typography>

      <Typography className={classes.text}>
        <Button component={NavLink} to={bookingPath()} variant="contained" color="primary" disableElevation>
          Finish booking
        </Button>
      </Typography>
      <Typography className={classes.text}>
        Questions?{' '}
        <Link {...whatsappChatProps("Hi GoWashMyCar! I have a question about my booking 📱")} color="secondary">
          Message us on WhatsApp.
        </Link>
      </Typography>
      <Typography className={classes.text}>
        <NavLink to="/">Return to the homepage</NavLink>
      </Typography>
    </div>

  )
})

export const CheckoutCancel = React.memo(() => {

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <CheckoutCancelingComponent/>
  )
})
